import React from "react";
import ContentPageTemplate from "../components/ContentPageTemplate";
import { marketingPages } from "../data/marketingPages";

export default function MarketingDigitaleVermarktung() {
  return <ContentPageTemplate {...marketingPages.digitaleVermarktung} />;
}
